import * as React from 'react';
import { TextField, TextFieldProps } from 'ui';
import {
  checkFormHasError,
  getFormHelperText,
  handleBlurFormField,
  handleChangeFormField,
} from '@tock/shared/ui/forms/formHelpers';
import { useField } from 'formik';

function FormTextField({ helperText, ...rest }: TextFieldProps) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [field, meta] = useField(rest as any);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    handleChangeFormField(field, event, rest.onChange);

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) =>
    handleBlurFormField(field, event, rest.onBlur);

  const hasError = checkFormHasError(meta);

  const helperTextValue = getFormHelperText(hasError, meta, helperText);

  return (
    <TextField
      id={rest.id ?? rest.name}
      error={hasError}
      helperText={helperTextValue}
      {...field}
      {...rest}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
}

export default FormTextField;
